/** Angular */
import { NgModule, ModuleWithProviders, Provider, SkipSelf, Optional } from '@angular/core';
/** Services */
import { BydTokenService } from '../services/byd-token.service';
import { BydConfigService } from '../services/byd-config.service';
/**
 * Use this BydCoreServiceModule to provide BydCoreService.
 */
@NgModule({ providers: [BydTokenService, BydConfigService] })
export class BydCoreServiceModule {
  /**
   * Creates an instance of BydCoreServiceModule.
   * Prevent reimport of BydCoreServiceModule.
   *
   * @param bydCoreServiceModule the BydCoreServiceModule instance
   */
  constructor(@Optional() @SkipSelf() bydCoreServiceModule?: BydCoreServiceModule) {
    if (bydCoreServiceModule) {
      throw new Error('BydCoreServiceModule is already loaded. Import it in the AppModule only');
    }
  }

  /**
   * Use this method in the root module to provide the BydCoreService.
   *
   * @param coreServiceProvider the provider
   * @returns ModuleWithProviders
   * @example BydCoreServiceModule.forRoot({ // single provider
   *            provide: BYD_API_INJECTION_TOKEN,
   *            useValue: {
   *              apiUrl: environment.settings.ROAZHON_URL,
   *              apiScope: 'frontged',
   *            },
   *          }),
   * @example BydCoreServiceModule.forRoot([{ // multi provider
   *            provide: BYD_API_INJECTION_TOKEN,
   *            useValue: {
   *              api_1_Url: environment.settings.API_1_URL,
   *              api_1_Scope: 'frontged',
   *             },
   *            multi: true,
   *            },
   *            {
   *            provide: BYD_API_INJECTION_TOKEN,
   *            useValue: {
   *              api_2_Url: environment.settings.API_2_URL,
   *              api_2_Scope: 'frontged',
   *             },
   *            multi: true,
   *          }]),
   */
  static forRoot(coreServiceProvider: Provider): ModuleWithProviders<BydCoreServiceModule> {
    return {
      ngModule: BydCoreServiceModule,
      providers: [BydTokenService, BydConfigService, coreServiceProvider],
    };
  }
}
